import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

interface Props {
  roles?: string[];
  children: ReactNode;
}

export function AccessGuard({ roles, children }: Props) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: "2rem", color: "#666" }}>Завантаження…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div style={{ padding: "2rem", maxWidth: 600 }}>
        <h2 style={{ color: "#c53030" }}>403 Forbidden</h2>
        <p>У вас немає доступу до цієї сторінки. Поточна роль: <strong>{user.role}</strong></p>
        <p>Потрібно: <strong>{roles.join(" або ")}</strong></p>
      </div>
    );
  }
  return <>{children}</>;
}
